import { isDefined } from "@clipboard-health/util-ts";
import { formatTimeWithTimezone } from "@src/appV2/redesign/utils/formatTimeWithTimezone";
import { differenceInMinutes } from "date-fns";

import { type TimesheetEntry } from "../hooks/useTimesheetEntry";

interface FormatBreakDisplayParams {
  displayTimesheet?: TimesheetEntry;
  workplaceTimezone: string;
}

function formatBreakTakenMessage(
  displayTimesheet: TimesheetEntry,
  workplaceTimezone: string
): string {
  if (isDefined(displayTimesheet.breakStartTime) && isDefined(displayTimesheet.breakEndTime)) {
    const breakMinutes = differenceInMinutes(
      displayTimesheet.breakEndTime,
      displayTimesheet.breakStartTime
    );
    const startTime = formatTimeWithTimezone(
      displayTimesheet.breakStartTime,
      workplaceTimezone,
      false
    );

    return `${startTime}・${breakMinutes} min`;
  }

  return "Break skipped";
}

export function formatBreakDisplay(params: FormatBreakDisplayParams): string {
  const { displayTimesheet, workplaceTimezone } = params;

  if (!isDefined(displayTimesheet)) {
    return "";
  }

  const isSkipped = !isDefined(displayTimesheet.breakStartTime);

  if (isSkipped) {
    return "Break skipped";
  }

  return formatBreakTakenMessage(displayTimesheet, workplaceTimezone);
}
